export default __webpack_public_path__ + "static/media/Rectangle 53(4).bc328a29.png";